export const socials = [
  {
    id: 1,
    name: "Facebook",
    link: "https://www.facebook.com/people/SoftRyzen/100095070398788/",
    icon: "icon-facebook",
  },
  {
    id: 2,
    name: "Instagram",
    link: "https://www.instagram.com/softryzen",
    icon: "icon-instagram",
  },
];
